export default __webpack_public_path__ + "static/media/e-merkator-blog-pt.13933d90.png";